import { createActionFactory } from '../../common/redux';

const { createAction } = createActionFactory('Console => ');

const dismissApiError = createAction('dismiss API error');

const setAlertMessage = createAction('set alert message', ({ messageType, header, byline, timeout }) => ({
  messageType,
  header,
  byline,
  timeout,
}));
const dismissAlertMessage = createAction('dismiss alert message');

export default { dismissApiError, setAlertMessage, dismissAlertMessage };
